function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "2.581 23.825 27.419 23.825 15 16.372 2.581 23.825",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.418 6.175 2.581 6.175 15 13.628 27.418 6.175",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 6.175 0 23.825 .295 23.825 15 15 .295 6.175 0 6.175",
    style: {
      fill: "#43b02a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30 23.825 30 6.175 29.705 6.175 15 15 29.705 23.825 30 23.825",
    style: {
      fill: "#43b02a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30 22.63 17.287 15 30 7.371 30 6.175 27.418 6.175 15 13.628 2.581 6.175 0 6.175 0 7.37 12.713 15 0 22.629 0 23.825 2.581 23.825 15 16.372 27.419 23.825 30 23.825 30 22.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M15,11.34l.309.536h.618l-.309.536.309.536h-.618l-.309.535-.309-.536h-.618l.309-.536-.309-.536h.618l.309-.535Z",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,13.588l-.34-.588h-.679l.339-.588-.339-.588h.679l.34-.59.34.588h.679l-.339.588.339.588h-.679l-.34.59ZM14.165,12.894h.556l.279.482.279-.482h.556l-.279-.482.279-.482h-.556l-.279-.482-.279.482h-.556l.279.482-.279.482Z",
    style: {
      fill: "#43b02a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b1",
    "data-name": "b",
    d: "M18.168,16.829h-.618l-.309.536-.309-.536h-.618l.309-.536-.309-.536h.618l.309-.536.309.536h.618l-.309.536.309.536Z",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.242,17.47l-.34-.588h-.679l.339-.588-.34-.589h.679l.339-.588.34.588h.679l-.339.588.34.589h-.679l-.339.588ZM16.405,16.777h.556l.279.482.279-.482h.556l-.279-.482.279-.482h-.556l-.279-.482-.279.482h-.556l.279.482-.279.482Z",
    style: {
      fill: "#43b02a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2",
    "data-name": "b",
    d: "M11.831,16.829l.309-.536-.309-.536h.618l.309-.536.309.536h.618l-.309.536.309.536h-.618l-.309.536-.309-.536h-.618Z",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.758,17.47l-.339-.588h-.679l.34-.589-.339-.588h.679l.34-.588.339.588h.679l-.34.589.339.588h-.679l-.34.588ZM11.923,16.777h.556l.279.482.279-.482h.556l-.279-.482.279-.482h-.556l-.279-.482-.279.482h-.556l.279.482-.279.482Z",
    style: {
      fill: "#43b02a"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/BI.07aa1e66f09fb3e38857de2345a743e4.svg";
export { ForwardRef as ReactComponent };